export const HomeIcon = ({
    width = '2.4rem',
    height = '2.4rem',
    className,
}) => (
    <svg
        role="img"
        height={height}
        width={width}
        className={className}
        viewBox="0 0 24 24"
    >
        <path d="M12.5 3.247a1 1 0 00-1 0L4 7.577V20h4.5v-6a1 1 0 011-1h5a1 1 0 011 1v6H20V7.577l-7.5-4.33zm-2-1.732a3 3 0 013 0l7.5 4.33a2 2 0 011 1.732V21a1 1 0 01-1 1h-6.5a1 1 0 01-1-1v-6h-3v6a1 1 0 01-1 1H3a1 1 0 01-1-1V7.577a2 2 0 011-1.732l7.5-4.33z"></path>
    </svg>
);

export const HomeIconActive = ({
    width = '2.4rem',
    height = '2.4rem',
    className,
}) => (
    <svg
        role="img"
        height={height}
        width={width}
        className={className}
        viewBox="0 0 24 24"
    >
        <path d="M13.5 1.515a3 3 0 00-3 0L3 5.845a2 2 0 00-1 1.732V21a1 1 0 001 1h6a1 1 0 001-1v-6h4v6a1 1 0 001 1h6a1 1 0 001-1V7.577a2 2 0 00-1-1.732l-7.5-4.33z"></path>
    </svg>
);

export const SearchIcon = ({
    width = '2.4rem',
    height = '2.4rem',
    className,
}) => (
    <svg
        role="img"
        height={height}
        width={width}
        className={className}
        viewBox="0 0 24 24"
    >
        <path d="M10.533 1.279c-5.18 0-9.407 4.14-9.407 9.279s4.226 9.279 9.407 9.279c2.234 0 4.29-.77 5.907-2.058l4.353 4.353a1 1 0 101.414-1.414l-4.344-4.344a9.157 9.157 0 002.077-5.816c0-5.14-4.226-9.28-9.407-9.28zm-7.407 9.279c0-4.006 3.302-7.28 7.407-7.28s7.407 3.274 7.407 7.28-3.302 7.279-7.407 7.279-7.407-3.273-7.407-7.28z"></path>
    </svg>
);

export const SearchIconActive = ({
    width = '2.4rem',
    height = '2.4rem',
    className,
}) => (
    <svg
        role="img"
        height={height}
        width={width}
        className={className}
        viewBox="0 0 24 24"
    >
        <path d="M15.356 10.558c0 2.623-2.16 4.75-4.823 4.75-2.664 0-4.824-2.127-4.824-4.75s2.16-4.75 4.824-4.75c2.664 0 4.823 2.127 4.823 4.75z"></path>
        <path d="M1.126 10.558c0-5.14 4.226-9.28 9.407-9.28 5.18 0 9.407 4.14 9.407 9.28a9.157 9.157 0 01-2.077 5.816l4.344 4.344a1 1 0 01-1.414 1.414l-4.353-4.353a9.454 9.454 0 01-5.907 2.058c-5.18 0-9.407-4.14-9.407-9.28zm9.407-7.28c-4.105 0-7.407 3.274-7.407 7.28s3.302 7.279 7.407 7.279 7.407-3.273 7.407-7.28c0-4.005-3.302-7.278-7.407-7.278z"></path>
    </svg>
);

export const LibraryIcon = ({
    width = '2.4rem',
    height = '2.4rem',
    className,
}) => (
    <svg
        role="img"
        height={height}
        width={width}
        className={className}
        viewBox="0 0 24 24"
    >
        <path d="M14.5 2.134a1 1 0 011 0l6 3.464a1 1 0 01.5.866V21a1 1 0 01-1 1h-6a1 1 0 01-1-1V3a1 1 0 01.5-.866zM16 4.732V20h4V7.041l-4-2.309zM3 22a1 1 0 01-1-1V3a1 1 0 012 0v18a1 1 0 01-1 1zm6 0a1 1 0 01-1-1V3a1 1 0 012 0v18a1 1 0 01-1 1z"></path>
    </svg>
);

export const LibraryIconActive = ({
    width = '2.4rem',
    height = '2.4rem',
    className,
}) => (
    <svg
        role="img"
        height={height}
        width={width}
        className={className}
        viewBox="0 0 24 24"
    >
        <path d="M3 22a1 1 0 01-1-1V3a1 1 0 012 0v18a1 1 0 01-1 1zM15.5 2.134A1 1 0 0014 3v18a1 1 0 001 1h6a1 1 0 001-1V6.464a1 1 0 00-.5-.866l-6-3.464zM9 2a1 1 0 00-1 1v18a1 1 0 102 0V3a1 1 0 00-1-1z"></path>
    </svg>
);

export const CreateIcon = ({
    width = '1.2rem',
    height = '1.2rem',
    className,
}) => (
    <svg
        role="img"
        height={height}
        width={width}
        className={className}
        aria-hidden="true"
        viewBox="0 0 16 16"
    >
        <path d="M15.25 8a.75.75 0 01-.75.75H8.75v5.75a.75.75 0 01-1.5 0V8.75H1.5a.75.75 0 010-1.5h5.75V1.5a.75.75 0 011.5 0v5.75h5.75a.75.75 0 01.75.75z"></path>
    </svg>
);

export const LikeIcon = ({
    width = '1.2rem',
    height = '1.2rem',
    className,
}) => (
    <svg
        role="img"
        height={height}
        width={width}
        className={className}
        aria-hidden="true"
        viewBox="0 0 16 16"
    >
        <path d="M15.724 4.22A4.313 4.313 0 0012.192.814a4.269 4.269 0 00-3.622 1.13.837.837 0 01-1.14 0 4.272 4.272 0 00-6.21 5.855l5.916 7.05a1.128 1.128 0 001.727 0l5.916-7.05a4.228 4.228 0 00.945-3.577z"></path>
    </svg>
);

export const DownloadIcon = ({
    width = '2rem',
    height = '2rem',
    className,
}) => (
    <svg
        role="img"
        height={height}
        width={width}
        className={className}
        viewBox="0 0 24 24"
    >
        <path d="M12 3a9 9 0 100 18 9 9 0 000-18zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12z"></path>
        <path d="M12 6.05a1 1 0 011 1v7.486l1.793-1.793a1 1 0 111.414 1.414L12 18.364l-4.207-4.207a1 1 0 111.414-1.414L11 14.536V7.05a1 1 0 011-1z"></path>
    </svg>
);

export const ArrowDownIcon = ({
    width = '1.6rem',
    height = '1.6rem',
    className,
}) => (
    <svg
        role="img"
        height={height}
        width={width}
        className={className}
        viewBox="0 0 16 16"
    >
        <path d="M14 6l-6 6-6-6h12z"></path>
    </svg>
);

export const ArrowUpIcon = ({
    width = '1.6rem',
    height = '1.6rem',
    className,
}) => (
    <svg
        role="img"
        height={height}
        width={width}
        className={className}
        viewBox="0 0 16 16"
    >
        <path d="M14 10L8 4l-6 6h12z"></path>
    </svg>
);

export const ShortcutIcon = ({
    width = '1.6rem',
    height = '1.6rem',
    className,
}) => (
    <svg
        role="img"
        height={height}
        width={width}
        className={className}
        viewBox="0 0 16 16"
    >
        <path d="M1 2.75A.75.75 0 011.75 2H7v1.5H2.5v11h10.219V9h1.5v6.25a.75.75 0 01-.75.75H1.75a.75.75 0 01-.75-.75V2.75z"></path>
        <path d="M15 1v4.993a.75.75 0 11-1.5 0V3.56L8.78 8.28a.75.75 0 01-1.06-1.06l4.72-4.72h-2.433a.75.75 0 010-1.5H15z"></path>
    </svg>
);

export const ArrowLeftIcon = ({
    width = '2.4rem',
    height = '2.4rem',
    className,
}) => (
    <svg
        role="img"
        height={height}
        width={width}
        className={className}
        viewBox="0 0 24 24"
    >
        <path d="M15.957 2.793a1 1 0 010 1.414L8.164 12l7.793 7.793a1 1 0 11-1.414 1.414L5.336 12l9.207-9.207a1 1 0 011.414 0z"></path>
    </svg>
);

export const ArrowRightIcon = ({
    width = '2.4rem',
    height = '2.4rem',
    className,
}) => (
    <svg
        role="img"
        height={height}
        width={width}
        className={className}
        viewBox="0 0 24 24"
    >
        <path d="M8.043 2.793a1 1 0 000 1.414L15.836 12l-7.793 7.793a1 1 0 101.414 1.414L18.664 12 9.457 2.793a1 1 0 00-1.414 0z"></path>
    </svg>
);

export const BigSearchIcon = ({
    width = '2.4rem',
    height = '2.4rem',
    className,
}) => (
    <svg
        role="img"
        height={height}
        width={width}
        className={className}
        aria-hidden="true"
        viewBox="0 0 24 24"
    >
        <path d="M10.533 1.279c-5.18 0-9.407 4.14-9.407 9.279s4.226 9.279 9.407 9.279c2.234 0 4.29-.77 5.907-2.058l4.353 4.353a1 1 0 101.414-1.414l-4.344-4.344a9.157 9.157 0 002.077-5.816c0-5.14-4.226-9.28-9.407-9.28zm-7.407 9.279c0-4.006 3.302-7.28 7.407-7.28s7.407 3.274 7.407 7.28-3.302 7.279-7.407 7.279-7.407-3.273-7.407-7.28z"></path>
    </svg>
);

export const ClearSearchIcon = ({
    width = '2.4rem',
    height = '2.4rem',
    className,
}) => (
    <svg
        role="img"
        height={height}
        width={width}
        className={className}
        viewBox="0 0 24 24"
    >
        <path d="M3.293 3.293a1 1 0 011.414 0L12 10.586l7.293-7.293a1 1 0 111.414 1.414L13.414 12l7.293 7.293a1 1 0 01-1.414 1.414L12 13.414l-7.293 7.293a1 1 0 01-1.414-1.414L10.586 12 3.293 4.707a1 1 0 010-1.414z"></path>
    </svg>
);

export const PlayIcon = ({
    width = '2.4rem',
    height = '2.4rem',
    className,
}) => (
    <svg
        height={height}
        width={width}
        className={className}
        viewBox="0 0 24 24"
    >
        <path d="M7.05 3.606l13.49 7.788a.7.7 0 010 1.212L7.05 20.394A.7.7 0 016 19.788V4.212a.7.7 0 011.05-.606z"></path>
    </svg>
);

export const PlayLargeIcon = ({
    width = '2.8rem',
    height = '2.8rem',
    className,
}) => (
    <svg
        height={height}
        width={width}
        className={className}
        viewBox="0 0 24 24"
    >
        <path d="M7.05 3.606l13.49 7.788a.7.7 0 010 1.212L7.05 20.394A.7.7 0 016 19.788V4.212a.7.7 0 011.05-.606z"></path>
    </svg>
);

export const PlayListIcon = ({
    width = '6.0rem',
    height = '6.1rem',
    className,
}) => (
    <svg
        height={height}
        width={width}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 80 81"
    >
        <path
            d="M25.6 11.565v45.38c-2.643-3.27-6.68-5.37-11.2-5.37-7.94 0-14.4 6.46-14.4 14.4s6.46 14.4 14.4 14.4 14.4-6.46 14.4-14.4v-51.82l48-10.205V47.2c-2.642-3.27-6.678-5.37-11.2-5.37-7.94 0-14.4 6.46-14.4 14.4s6.46 14.4 14.4 14.4S80 64.17 80 56.23V0L25.6 11.565zm-11.2 65.61c-6.176 0-11.2-5.025-11.2-11.2 0-6.177 5.024-11.2 11.2-11.2 6.176 0 11.2 5.023 11.2 11.2 0 6.174-5.026 11.2-11.2 11.2zm51.2-9.745c-6.176 0-11.2-5.024-11.2-11.2 0-6.174 5.024-11.2 11.2-11.2 6.176 0 11.2 5.026 11.2 11.2 0 6.178-5.026 11.2-11.2 11.2z"
            fillRule="evenodd"
        ></path>
    </svg>
);

export const HeartIcon = ({
    width = '3.2rem',
    height = '3.2rem',
    className,
}) => (
    <svg
        height={height}
        width={width}
        className={className}
        viewBox="0 0 24 24"
    >
        <path d="M5.21 1.57a6.757 6.757 0 016.708 1.545.124.124 0 00.165 0 6.741 6.741 0 015.715-1.78l.004.001a6.802 6.802 0 015.571 5.376v.003a6.689 6.689 0 01-1.49 5.655l-7.954 9.48a2.518 2.518 0 01-3.857 0L2.12 12.37A6.683 6.683 0 01.627 6.714 6.757 6.757 0 015.21 1.57zm3.12 1.803a4.757 4.757 0 00-5.74 3.725l-.001.002a4.684 4.684 0 001.049 3.969l.009.01 7.958 9.485a.518.518 0 00.79 0l7.968-9.495a4.688 4.688 0 001.049-3.965 4.803 4.803 0 00-3.931-3.794 4.74 4.74 0 00-4.023 1.256l-.008.008a2.123 2.123 0 01-2.9 0l-.007-.007a4.757 4.757 0 00-2.214-1.194z"></path>
    </svg>
);

export const HeartActiveIcon = ({
    width = '3.2rem',
    height = '3.2rem',
    className,
}) => (
    <svg
        height={height}
        width={width}
        className={className}
        viewBox="0 0 24 24"
    >
        <path d="M8.667 1.912a6.257 6.257 0 00-7.462 7.677c.24.906.683 1.747 1.295 2.457l7.955 9.482a2.015 2.015 0 003.09 0l7.956-9.482a6.188 6.188 0 001.382-5.234l-.49.097.49-.099a6.303 6.303 0 00-5.162-4.98h-.002a6.24 6.24 0 00-5.295 1.65.623.623 0 01-.848 0 6.257 6.257 0 00-2.91-1.568z"></path>
    </svg>
);

export const MoreMenuIcon = ({
    width = '3.2rem',
    height = '3.2rem',
    className,
}) => (
    <svg
        height={height}
        width={width}
        className={className}
        viewBox="0 0 24 24"
    >
        <path d="M4.5 13.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm15 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-7.5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"></path>
    </svg>
);

export const SmallRightArrowIcon = ({
    width = '1.6rem',
    height = '1.6rem',
    className,
}) => (
    <svg
        height={height}
        width={width}
        className={className}
        viewBox="0 0 16 16"
    >
        <path d="M14 10L8 4l-6 6h12z"></path>
    </svg>
);

export const ClockIcon = ({
    width = '1.6rem',
    height = '1.6rem',
    className,
}) => (
    <svg
        height={height}
        width={width}
        className={className}
        viewBox="0 0 16 16"
    >
        <path d="M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8z"></path>
        <path d="M8 3.25a.75.75 0 01.75.75v3.25H11a.75.75 0 010 1.5H7.25V4A.75.75 0 018 3.25z"></path>
    </svg>
);

export const PipToggleIcon = ({
    width = '1.6rem',
    height = '1.6rem',
    className,
}) => (
    <svg
        height={height}
        width={width}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="currentColor" fillRule="evenodd">
            <path
                d="M1 3v9h14V3H1zm0-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z"
                fillRule="nonzero"
            ></path>
            <path d="M10 8h4v3h-4z"></path>
        </g>
    </svg>
);

export const PrevIcon = ({
    width = '1.6rem',
    height = '1.6rem',
    className,
}) => (
    <svg height={height} width={width} className={className}>
        <path d="M3.3 1a.7.7 0 01.7.7v5.15l9.95-5.744a.7.7 0 011.05.606v12.575a.7.7 0 01-1.05.607L4 9.149V14.3a.7.7 0 01-.7.7H1.7a.7.7 0 01-.7-.7V1.7a.7.7 0 01.7-.7h1.6z"></path>
    </svg>
);

export const NextIcon = ({
    width = '1.6rem',
    height = '1.6rem',
    className,
}) => (
    <svg height={height} width={width} className={className}>
        <path d="M12.7 1a.7.7 0 00-.7.7v5.15L2.05 1.107A.7.7 0 001 1.712v12.575a.7.7 0 001.05.607L12 9.149V14.3a.7.7 0 00.7.7h1.6a.7.7 0 00.7-.7V1.7a.7.7 0 00-.7-.7h-1.6z"></path>
    </svg>
);

export const ShuffleIcon = ({
    width = '1.6rem',
    height = '1.6rem',
    className,
}) => (
    <svg height={height} width={width} className={className}>
        <path d="M13.151.922a.75.75 0 10-1.06 1.06L13.109 3H11.16a3.75 3.75 0 00-2.873 1.34l-6.173 7.356A2.25 2.25 0 01.39 12.5H0V14h.391a3.75 3.75 0 002.873-1.34l6.173-7.356a2.25 2.25 0 011.724-.804h1.947l-1.017 1.018a.75.75 0 001.06 1.06L15.98 3.75 13.15.922zM.391 3.5H0V2h.391c1.109 0 2.16.49 2.873 1.34L4.89 5.277l-.979 1.167-1.796-2.14A2.25 2.25 0 00.39 3.5z"></path>
        <path d="M7.5 10.723l.98-1.167.957 1.14a2.25 2.25 0 001.724.804h1.947l-1.017-1.018a.75.75 0 111.06-1.06l2.829 2.828-2.829 2.828a.75.75 0 11-1.06-1.06L13.109 13H11.16a3.75 3.75 0 01-2.873-1.34l-.787-.938z"></path>
    </svg>
);

export const RepeatIcon = ({
    width = '1.6rem',
    height = '1.6rem',
    className,
}) => (
    <svg height={height} width={width} className={className}>
        <path d="M0 4.75A3.75 3.75 0 013.75 1h8.5A3.75 3.75 0 0116 4.75v5a3.75 3.75 0 01-3.75 3.75H9.81l1.018 1.018a.75.75 0 11-1.06 1.06L6.939 12.75l2.829-2.828a.75.75 0 111.06 1.06L9.811 12h2.439a2.25 2.25 0 002.25-2.25v-5a2.25 2.25 0 00-2.25-2.25h-8.5A2.25 2.25 0 001.5 4.75v5A2.25 2.25 0 003.75 12H5v1.5H3.75A3.75 3.75 0 010 9.75v-5z"></path>
    </svg>
);

export const LyricsIcon = ({
    width = '1.6rem',
    height = '1.6rem',
    className,
}) => (
    <svg height={height} width={width} className={className}>
        <path d="M13.426 2.574a2.831 2.831 0 00-4.797 1.55l3.247 3.247a2.831 2.831 0 001.55-4.797zM10.5 8.118l-2.619-2.62A63303.13 63303.13 0 004.74 9.075L2.065 12.12a1.287 1.287 0 001.816 1.816l3.06-2.688 3.56-3.129zM7.12 4.094a4.331 4.331 0 114.786 4.786l-3.974 3.493-3.06 2.689a2.787 2.787 0 01-3.933-3.933l2.676-3.045 3.505-3.99z"></path>
    </svg>
);

export const QueueIcon = ({
    width = '1.6rem',
    height = '1.6rem',
    className,
}) => (
    <svg height={height} width={width} className={className}>
        <path d="M15 15H1v-1.5h14V15zm0-4.5H1V9h14v1.5zm-14-7A2.5 2.5 0 013.5 1h9a2.5 2.5 0 010 5h-9A2.5 2.5 0 011 3.5zm2.5-1a1 1 0 000 2h9a1 1 0 100-2h-9z"></path>
    </svg>
);

export const ControlIcon = ({
    width = '1.6rem',
    height = '1.6rem',
    className,
}) => (
    <svg height={height} width={width} className={className}>
        <path d="M6 2.75C6 1.784 6.784 1 7.75 1h6.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0114.25 15h-6.5A1.75 1.75 0 016 13.25V2.75zm1.75-.25a.25.25 0 00-.25.25v10.5c0 .138.112.25.25.25h6.5a.25.25 0 00.25-.25V2.75a.25.25 0 00-.25-.25h-6.5zm-6 0a.25.25 0 00-.25.25v6.5c0 .138.112.25.25.25H4V11H1.75A1.75 1.75 0 010 9.25v-6.5C0 1.784.784 1 1.75 1H4v1.5H1.75zM4 15H2v-1.5h2V15z"></path>
        <path d="M13 10a2 2 0 11-4 0 2 2 0 014 0zm-1-5a1 1 0 11-2 0 1 1 0 012 0z"></path>
    </svg>
);

export const VolumeIcon = ({
    width = '1.6rem',
    height = '1.6rem',
    className,
}) => (
    <svg height={height} width={width} className={className}>
        <path d="M9.741.85a.75.75 0 01.375.65v13a.75.75 0 01-1.125.65l-6.925-4a3.642 3.642 0 01-1.33-4.967 3.639 3.639 0 011.33-1.332l6.925-4a.75.75 0 01.75 0zm-6.924 5.3a2.139 2.139 0 000 3.7l5.8 3.35V2.8l-5.8 3.35zm8.683 4.29V5.56a2.75 2.75 0 010 4.88z"></path>
        <path d="M11.5 13.614a5.752 5.752 0 000-11.228v1.55a4.252 4.252 0 010 8.127v1.55z"></path>
    </svg>
);

export const PauseIcon = ({
    width = '1.6rem',
    height = '1.6rem',
    className,
}) => (
    <svg height={height} width={width} className={className}>
        <path d="M2.7 1a.7.7 0 00-.7.7v12.6a.7.7 0 00.7.7h2.6a.7.7 0 00.7-.7V1.7a.7.7 0 00-.7-.7H2.7zm8 0a.7.7 0 00-.7.7v12.6a.7.7 0 00.7.7h2.6a.7.7 0 00.7-.7V1.7a.7.7 0 00-.7-.7h-2.6z"></path>
    </svg>
);

export const PauseLargeIcon = ({
    width = '2.8rem',
    height = '2.8rem',
    className,
}) => (
    <svg
        height={height}
        width={width}
        className={className}
        viewBox="0 0 24 24"
    >
        <path d="M5.7 3a.7.7 0 00-.7.7v16.6a.7.7 0 00.7.7h2.6a.7.7 0 00.7-.7V3.7a.7.7 0 00-.7-.7H5.7zm10 0a.7.7 0 00-.7.7v16.6a.7.7 0 00.7.7h2.6a.7.7 0 00.7-.7V3.7a.7.7 0 00-.7-.7h-2.6z"></path>
    </svg>
);
